import {
  Box,
  DropzoneReadonly,
  FiAlertCircle,
  FileAttachmentIcon,
  Flex,
  FormControl,
  Text,
} from '@agrotoken-tech/ui';
import { FileMimeType, VALIDATION_STATUSES } from '@bcba/types';
import { useState } from 'react';
import { downloadDocument } from '../../utils/downloadDocument.utils';
import { S3FileUploader } from '@bcba/frontend-utils';
import { getS3SignedUrl } from '../../services/documents/getS3SignedUrl';

interface SignupRequestLegalRepresentativeDocumentProps {
  labelDropzone: string;
  formMethods: any;
  document: any;
  keyNameDropzone: string;
  isRequired: boolean | string;
  requestUploadFileMessage?: string | null;
}

export const SignupRequestLegalRepresentativeDocument = ({
  labelDropzone,
  formMethods,
  document,
  keyNameDropzone,
  isRequired,
  requestUploadFileMessage,
}: SignupRequestLegalRepresentativeDocumentProps) => {
  const [showDropZone, setShowDropZone] = useState<Boolean>(!Boolean(document));
  const [isDownloadingDocument, setIsDownloadingDocument] = useState(false);
  const { setValue, resetField } = formMethods;
  const status = document?.status;
  const validationMessage = document?.validationMessage || '';
  const changesRequest =
    status === VALIDATION_STATUSES.PENDING_CHANGE_REQUEST &&
    Boolean(validationMessage);

  const handleDeleteFileClick = () => {
    setValue(`${keyNameDropzone}.file.s3TempKey`, undefined, {
      shouldDirty: true,
    });
    setValue(`${keyNameDropzone}.file`, undefined, {
      shouldDirty: true,
    });
    setValue(`${keyNameDropzone}.validationMessage`, undefined, {
      shouldDirty: true,
    });
    setShowDropZone(true);
  };

  return (
    <FormControl mt={6} key={document?.documentUuid}>
      {showDropZone ? (
        <Box>
          <S3FileUploader
            fieldPrefix={`${keyNameDropzone}.file.s3TempKey`}
            label={labelDropzone}
            getS3PreSignedUrl={getS3SignedUrl}
            onFileUploadSuccess={async (fileName, mimeType, s3TempKey) => {
              setValue(`${keyNameDropzone}.file.name`, fileName);
              setValue(
                `${keyNameDropzone}.file.mimeType`,
                mimeType as FileMimeType,
              );
              setValue(`${keyNameDropzone}.file.s3TempKey`, s3TempKey);
              setValue(`${keyNameDropzone}.keepOriginal`, false, {
                shouldDirty: true,
              });
            }}
            onDeleteClick={() => {
              resetField(`${keyNameDropzone}.file.s3TempKey`);
              resetField(`${keyNameDropzone}.file.name`);
              resetField(`${keyNameDropzone}.file.mimeType`);
            }}
          />
          {requestUploadFileMessage && (
            <Flex align="center" mt="0.25rem">
              <FiAlertCircle
                color={'var(--chakra-colors-content-destructive)'}
              />
              <Box ml="1.5">
                <Text
                  key={requestUploadFileMessage}
                  fontSize="sm"
                  variant="medium"
                  color="content-destructive"
                >
                  {requestUploadFileMessage}
                </Text>
              </Box>
            </Flex>
          )}
        </Box>
      ) : (
        <DropzoneReadonly
          label={labelDropzone}
          onDelete={changesRequest ? handleDeleteFileClick : undefined}
          hasError={changesRequest}
          leftIcon={FileAttachmentIcon}
          fileName={document?.originalFileName}
          rejectionMessage={validationMessage}
          onClick={() => {
            setIsDownloadingDocument(true);
            downloadDocument(document?.documentUuid);
            setIsDownloadingDocument(false);
          }}
          isLoading={isDownloadingDocument}
        />
      )}
    </FormControl>
  );
};

export default SignupRequestLegalRepresentativeDocument;
